module.exports = __webpack_public_path__ + "static/media/windows-option-regular.e605cd37.png";